import styled from 'styled-components';

export const TopBottomIndentsWrapper = styled.div`
  display: flex;
  padding: ${({ theme }): string => `${theme.spacers!.spacer06}`} 0;
`;
